export const MainPipeline = {
    methods: {
        checkIfSalesBillOfMaterial(task,itemTask){
            let items='';
            if ( task[itemTask].length == undefined) {
              items = Object.values( task[itemTask]);
            } else items =  task[itemTask];
            const keyToCheck = 'parentItemId';
            const hasKey = items.some(item => item.hasOwnProperty(keyToCheck));
            return hasKey;
          },
          toLowerArticleNumber(item) {
            let searchList = this.search
              .toLowerCase()
              .split(/(\s+)/)
              .filter(function (e) {
                return e.trim().length > 0;
              });
            if (
              item.articleNumber &&
              searchList.some((v) => item.articleNumber.toLowerCase().includes(v))
            ) {
              return true;
            } else return false;
          },
          toLowerTitle(item) {
            let searchList = this.search
              .toLowerCase()
              .split(/(\s+)/)
              .filter(function (e) {
                return e.trim().length > 0;
              });
            if (
              item.title !== undefined &&
              searchList.some((v) => item.title.toLowerCase().includes(v))
            ) {
              return true;
            } else {
              return false;
            }
          },
          toLowerTask(task) {
            let searchList = this.search
              .toLowerCase()
              .split(/(\s+)/)
              .filter(function (e) {
                return e.trim().length > 0;
              });
            if (
              task.orderNumber &&
              searchList.some((v) => task.orderNumber.toLowerCase().includes(v))
            ) {
              return true;
            } else if (
              task.salesOrderNumber &&
              searchList.some((v) => task.salesOrderNumber.toLowerCase().includes(v))
            ) {
              return true;
            } else return false;
          },
    }
}


